export const urlFormatter = (origin_url: string) => {
  if (origin_url === '') return '';

  const isHTTP = origin_url.slice(0, 7) === 'http://';
  const isHTTPS = origin_url.slice(0, 8) === 'https://';

  let protocol = '';

  if (!isHTTP && !isHTTPS) {
    try {
      const url = new URL(origin_url);
      protocol = url.protocol;
    } catch {
      protocol = 'https';
    }

    return `${protocol}://${origin_url}`;
  } else {
    return origin_url;
  }
};
